import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { NotificationService } from '@core/service';
import { Router } from '@angular/router';

const ERROR_CODES = {
  'General-123': 'Resource Access Denied. The requester is not associated with provider NPI.'
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private readonly notificationService: NotificationService,
    private readonly router: Router,
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const code = error.error?.report?.code;
          const message = ERROR_CODES[code];

          if (message) {
            this.notificationService.showError(message);
          }

          switch (code) {
            case 'General-123':
              this.router.navigateByUrl('/').then(() => setTimeout(() => location.reload(), 3000));
              return EMPTY;
            default:
              return throwError(() => error);
          }
        }));
  }
}
